import { render } from "./AppWrapper.vue?vue&type=template&id=27e0cc7a&lang=pug"
import script from "./AppWrapper.vue?vue&type=script&lang=ts"
export * from "./AppWrapper.vue?vue&type=script&lang=ts"

import "./AppWrapper.vue?vue&type=style&index=0&id=27e0cc7a&lang=scss"
script.render = render

export default script